import { render, staticRenderFns } from "./pointChangeHistory.vue?vue&type=template&id=262da29a&scoped=true"
import script from "./pointChangeHistory.vue?vue&type=script&lang=js"
export * from "./pointChangeHistory.vue?vue&type=script&lang=js"
import style0 from "./pointChangeHistory.vue?vue&type=style&index=0&id=262da29a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262da29a",
  null
  
)

export default component.exports